<template>
    <common-modal :width="'extra-large'" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <main>
                <ratings-summary
                    :ratingsWithGrades="ratings"
                    :summaryText="summaryText"
                    :summarySubText="summarySubText"
                    :maxGrade="maxGrade"
                    :numberedList="numberedList"
                    :highlightedRatingKey="highlightedRatingKey"
                ></ratings-summary>
            </main>

            <footer>
                <common-buttons>
                    <common-button
                        :label="$t('pages.referrals.update.ratings_summary_modal.buttons.close')"
                        type="primary"
                        size="large"
                        @click="emitEvent({ name: 'close', payload: {} })"
                    ></common-button>
                </common-buttons>
            </footer>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import RatingsSummary from './RatingsSummary'

    export default {
        components: {
            RatingsSummary,
        },
        props: {
            ratings: { type: Array, required: true },
            summaryText: { type: String, required: true },
            summarySubText: { type: String, default: '' },
            maxGrade: { type: Number, required: true },
            numberedList: { type: Boolean, default: true },
            highlightedRatingKey: { type: String, required: false, default: null },
        },
    }
</script>

<style scoped></style>
